import { render } from "./addRecord.vue?vue&type=template&id=e3fa8b32&scoped=true"
import script from "./addRecord.vue?vue&type=script&lang=js"
export * from "./addRecord.vue?vue&type=script&lang=js"

import "./addRecord.vue?vue&type=style&index=0&id=e3fa8b32&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fa8b32"]])

export default __exports__